import { render, staticRenderFns } from "./RockslideObjectSelector.vue?vue&type=template&id=562d5381&scoped=true"
import script from "./RockslideObjectSelector.vue?vue&type=script&lang=js"
export * from "./RockslideObjectSelector.vue?vue&type=script&lang=js"
import style0 from "./RockslideObjectSelector.vue?vue&type=style&index=0&id=562d5381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d5381",
  null
  
)

export default component.exports